import React from "react";
import styles from "./custom-tag.module.css";
import { Typography } from "antd";
import SVGIcon from "../../constants/SVGIcon";

const CustomTag = ({
  color,
  background,
  borderColor,
  fontSize = "12px",
  text,
  borderRadius,
  minWidth,
  ticked,
  height,
  cursor,
  handleToggleChecked = () => {},
  name
}) => (
  <div
    className={styles["custom-tag-container"]}
    style={{
      minWidth: minWidth ?? "fit-content",
      flexDirection: ticked ? "row" : "column",
      borderRadius: borderRadius ?? "3px",
      border: `1px solid ${borderColor}`,
      background: background,
      height: height ?? "auto",
      cursor: cursor ?? "auto"
    }} 
    onClick={() => handleToggleChecked(name)}
  >
    {ticked && (
      <>
        <SVGIcon
          name={"tick"}
          width={"14"}
          height={"10"}
          className="anticon"
          stroke={"rgba(136, 136, 136, 1)"}
        />
      </>
    )}
    <Typography
      className={styles["custom-tag-text"]}
      style={{
        color: color,
        fontSize: fontSize,
      }}
    >
      {text}
    </Typography>
  </div>
);

export default CustomTag;
